import { IntroCopy } from './IntroCopy';
import { IntroMetrics } from './IntroMetrics';

export const IntroductionSection = () => (
<section data-testid="home-introduction" className="introduction-section">
<IntroMetrics />
<IntroCopy />
</section>
);
